import D2C_Entity from './Entity'
import api from '@/api'
import store from '@/store'

class D2C_User extends D2C_Entity {
  target = 'user'
  icon = 'user'
  static objectType = 'entityType'
  static typeName = 'user'
  static create(props) {
    return new D2C_User(props)
  }
  get _ownAccounts() {
    return store.getters.accounts.filter(account => account.owner === this.id)
  }
  get _defaultAccout() {
    return store.getters.accountsById[this.defaultAcc]
  }
  updateData(data) {
    const newData = {...this.data}
    for (var key in data) {
      newData[key] = data[key]
    }
    api.updateUserData(newData)
  }
  readTip(id) {
    if (id) {
      const hideTips = this.data.hideTips ? [...this.data.hideTips] : []
      if (!this.data.hideTips.includes(id)) {
        hideTips.push(id)
      }
      this.updateData({hideTips})
    }
  }
}

export default D2C_User
